<template>
  <el-dialog
    class="init-org-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="25vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="CA" prop="CAId">
        <el-select v-model="editForm.CAId" placeholder="请选择" clearable class="auto-width">
          <el-option v-for="item in options" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="组织ID" prop="OrgId">
        <el-input v-model="editForm.OrgId"></el-input>
      </el-form-item>
      <el-form-item label="组织名称" prop="OrgName">
        <el-input v-model="editForm.OrgName"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'InitOrgCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 85
  },
  data() {
    return {
      disabled: false,
      title: '申请IBC组织证书',
      dialogVisible: false,
      editForm: {
        CAId: '',
        OrgId: '',
        OrgName: '',
        Type: 0
      },
      editRules: {
        CAId: [{ required: true, message: '请选择CA证书', trigger: 'blur' }],
        OrgName: [{ required: true, message: '请填写组织名称', trigger: 'blur' }],
        OrgId: [{ required: true, message: '请填写组织ID', trigger: 'blur' }]
      },
      options: [],
      adaptationVars: {
        formLabelWidth: 85
      }
    }
  },
  methods: {
    getOptions() {
      this.$apis.certificate.getCaList({ limit: 50, offset: 0 }).then(res => {
        if (res.data && res.data.items) {
          this.options = res.data.items
        }
      })
    },
    handleCancel() {
      this.editForm = {
        CAId: '',
        OrgId: '',
        OrgName: '',
        Type: 0
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.dialogVisible = false
    },
    handleOpen() {
      this.getOptions()
      this.dialogVisible = true
    },
    handleOk() {
      // const testResult = this.$utils.checkCertificateName(this.editForm.OrgName)
      // if (testResult) {
      //   this.$message.error(testResult)
      //   return;
      // }
      this.disabled = true
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$apis.certificate
            .initOrg(this.editForm)
            .then(res => {
              this.$message.success('申请组织证书成功！')
              this.$emit('update:list')
              this.handleCancel()
            })
            .catch(err => {
              this.disabled = false
              return
            })
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.init-org-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--common-dialog-right);
  }
}

</style>
